__webpack_require__.p = "/dev/wip-minimap-better-bondaries/";